import { useState, useEffect, useRef } from 'react';
import queryString from 'utils/queryString';
import { useHash } from 'react-use';

const getHashQuery = hash => {
  return queryString.parse(hash);
};

const useHashQuery = (name, defaultValue = undefined, parser = val => val) => {
  const [hash, setHash] = useHash()

  const [value, setValue] = useState(parser(getHashQuery(hash)[name] ?? defaultValue));

  const valueRef = useRef(value);
  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const queryRef = useRef(getHashQuery(hash));
  useEffect(() => {
    queryRef.current = getHashQuery(hash)
  }, [hash])

  useEffect(() => {
    const query = getHashQuery(hash)
    if (query[name] !== undefined) {
      if (valueRef.current !== query[name]) {
        setValue(parser(query[name]));
      }
    } else {
      setValue(defaultValue)
    }
  }, [hash, name, defaultValue]);

  useEffect(() => {
    const newQuery = {
      ...queryRef.current,
      [name]: value
    }
    setHash(queryString.stringify(newQuery));
  }, [name, defaultValue, value]);

  return [value, setValue];
};

export default useHashQuery;
